/**
 * TF Apply Form - Tab switching, validation, and form submission
 * Based on register-page-template.liquid submission logic
 */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    initTfApplyForm();
  });

  function initTfApplyForm() {
    const wrapper = document.querySelector('.tf-apply-wrapper');
    if (!wrapper) return;

    const form = document.getElementById('tf-apply-form');
    const tabs = wrapper.querySelectorAll('.tf-apply-tab');
    const contents = wrapper.querySelectorAll('.tf-apply-content');
    const nextStep1Btn = document.getElementById('tf-next-step1');
    const backStep2Btn = document.getElementById('tf-back-step2');
    const nextStep2Btn = document.getElementById('tf-next-step2');
    const backStep3Btn = document.getElementById('tf-back-step3');
    const submitBtn = document.getElementById('tf-submit-btn');
    const switchAccountBtn = document.getElementById('tf-switch-account');

    let currentStep = 1;

    // Get the account type (role) from hidden input
    const accountTypeInput = form ? form.querySelector('input[name="contact[account_type]"]') : null;
    const accountType = accountTypeInput ? accountTypeInput.value : '';

    // Initialize notification system
    initNotificationSystem();

    // Initialize cat breeds multi-select
    initBreedsMultiSelect();

    // Initialize influencer platforms multi-select
    initPlatformsMultiSelect();

    // Switch account button handler
    if (switchAccountBtn) {
      switchAccountBtn.addEventListener('click', function() {
        const logoutUrl = this.getAttribute('data-logout-url');
        if (!logoutUrl) {
          window.location.reload();
          return;
        }
        fetch(logoutUrl, { method: 'GET', credentials: 'include' })
          .then(function() {
            window.location.reload();
          })
          .catch(function() {
            window.location.reload();
          });
      });
    }

    // Tab click handlers (only for completed tabs)
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const targetStep = parseInt(this.dataset.tab);
        if (targetStep < currentStep) {
          goToStep(targetStep);
        }
      });
    });

    // Step 1 Next button
    if (nextStep1Btn) {
      nextStep1Btn.addEventListener('click', function() {
        if (validateStep(1)) {
          goToStep(2);
        }
      });
    }

    // Step 2 Back button
    if (backStep2Btn) {
      backStep2Btn.addEventListener('click', function() {
        goToStep(1);
      });
    }

    // Step 2 Next button
    if (nextStep2Btn) {
      nextStep2Btn.addEventListener('click', function() {
        if (validateStep(2)) {
          populateConfirmView();
          goToStep(3);
        }
      });
    }

    // Step 3 Back button
    if (backStep3Btn) {
      backStep3Btn.addEventListener('click', function() {
        goToStep(2);
      });
    }

    // Form submission (from Step 3)
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();

        console.log('Form submitting...');

        // Disable submit button to prevent double submission
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Submitting...';
        }

        // Collect all form data into JSON
        const formData = collectFormData();
        const jsonData = JSON.stringify(formData);

        console.log('Collected form data:', formData);
        console.log('JSON data length:', jsonData.length, 'characters');

        // Get email for API request
        const emailInput = document.getElementById('contact-email');
        const customerEmail = emailInput ? emailInput.value : '';

        // Prepare data for API request
        const apiData = {
          email: customerEmail,
          role: accountType,
          phone: formData.phone || '',
          subscribed: formData.newsletter_subscription ? 'true' : 'false',
          applied_data: formData
        };

        console.log('Sending data to API:', apiData);
        console.log('API endpoint: /apps/tfacc/api/customers/partner');

        // Send data to API first
        fetch('/apps/tfacc/api/customers/partner', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(apiData)
        })
        .then(response => {
          console.log('API response status:', response.status);
          if (!response.ok) {
            return response.json().then(err => {
              let errorMessage = 'Submit failed, please try again';

              if (err.error) {
                errorMessage = err.error;
              } else if (err.message) {
                errorMessage = err.message;
              } else if (err.msg && err.msg !== 'error') {
                errorMessage = err.msg;
              }

              if (errorMessage.includes('already applied')) {
                errorMessage = 'You have already applied. Please do not submit again.';
              } else if (errorMessage.includes('already exists')) {
                errorMessage = 'The account already exists, please use another email or login directly.';
              }

              throw new Error(errorMessage);
            }).catch(parseError => {
              console.error('Failed to parse error response:', parseError);
              let errorMessage = 'Submit failed, please try again';
              if (response.status === 400) {
                errorMessage = 'The request parameters are incorrect, please check the information you filled in.';
              } else if (response.status === 409) {
                errorMessage = 'The account already exists, please use another email or login directly.';
              } else if (response.status >= 500) {
                errorMessage = 'Server error, please try again later.';
              }
              throw new Error(errorMessage);
            });
          }
          return response.json();
        })
        .then(data => {
          console.log('API response data:', data);
          console.log('API request successful');

          // Extract role and status from API response
          const apiRole = data.data ? data.data.role : accountType;
          const apiStatus = data.data ? data.data.status : 'applied';
          const apiMessage = data.data ? data.data.message : '';

          console.log('API Role:', apiRole, 'Status:', apiStatus);

          // Format data for contact form body
          let contactBody = `Application submitted - ${apiRole.toUpperCase()}\n\n`;
          contactBody += `Submission time: ${new Date().toLocaleString()}\n`;
          contactBody += `User role: ${apiRole}\n`;
          contactBody += `Status: ${apiStatus}\n`;

          if (formData.phone) {
            contactBody += `Contact number: ${formData.phone}\n`;
          }

          contactBody += `\n--- Detailed information (JSON format) ---\n`;
          contactBody += jsonData;

          // Store formatted data in contact[body] field
          const contactBodyField = document.getElementById('contact-body-json');
          if (contactBodyField) {
            contactBodyField.value = contactBody;
            console.log('Set contact[body] field value. Length:', contactBodyField.value.length);
          }

          // Remove name attributes from all non-contact fields to avoid conflicts
          const allFields = form.querySelectorAll('input, select, textarea');
          allFields.forEach(field => {
            if (field.name && !field.name.startsWith('contact[') &&
                field.id !== 'contact-body-json' && field.id !== 'contact-email') {
              field.removeAttribute('name');
            }
          });

          console.log('Submitting contact form...');

          // Submit the contact form
          // TODO: temporarily disable form submission
          // form.submit();

          // Show complete view after submit
          const confirmView = document.getElementById('tf-confirm-view');
          const completeView = document.getElementById('tf-complete-view');
          if (confirmView && completeView) {
            confirmView.style.display = 'none';
            completeView.style.display = 'block';

            // Update the complete view with API response data
            updateCompleteView(completeView, apiRole, apiStatus, apiMessage);
          }

          // Disable all tabs after submission
          tabs.forEach(tab => {
            tab.disabled = true;
            tab.classList.remove('active', 'completed');
          });
          tabs[2].classList.add('active');
        })
        .catch(error => {
          console.error('API request failed:', error);

          // Re-enable submit button on error
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Submit Application';
          }

          // Show error notification
          if (window.showPageNotification) {
            window.showPageNotification(error.message || 'Submit failed, please try again', 'error');
          } else {
            alert(error.message || 'Submit failed, please try again');
          }
        });
      });
    }

    /**
     * Initialize the page notification system
     */
    function initNotificationSystem() {
      // Create notification element if it doesn't exist
      if (!document.getElementById('tf-page-notification')) {
        const notificationHtml = `
          <div id="tf-page-notification" class="tf-page-notification" style="
            display: none;
            position: fixed;
            top: 20px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 10000;
            padding: 15px 20px;
            background-color: #fff;
            border-left: 4px solid #d9534f;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            border-radius: 4px;
            max-width: 90%;
            width: 500px;
          ">
            <div style="display: flex; align-items: center; justify-content: space-between; gap: 15px;">
              <div id="tf-page-notification-message" style="flex: 1; font-size: 14px; color: #333; line-height: 1.5;"></div>
              <button type="button" id="tf-page-notification-close" style="
                background: none; border: none; font-size: 20px; color: #666;
                cursor: pointer; padding: 0; width: 24px; height: 24px;
              ">×</button>
            </div>
          </div>
        `;
        document.body.insertAdjacentHTML('beforeend', notificationHtml);
      }

      const notification = document.getElementById('tf-page-notification');
      const notificationMessage = document.getElementById('tf-page-notification-message');
      const notificationClose = document.getElementById('tf-page-notification-close');

      // Function to show page notification
      window.showPageNotification = function(message, type, duration) {
        type = type || 'error';
        duration = duration || 5000;

        if (!notification || !notificationMessage) return;

        notificationMessage.textContent = message;

        // Set border color based on type
        if (type === 'success') {
          notification.style.borderLeftColor = '#28a745';
          notification.style.backgroundColor = '#d4edda';
        } else if (type === 'warning') {
          notification.style.borderLeftColor = '#ffc107';
          notification.style.backgroundColor = '#fff3cd';
        } else {
          notification.style.borderLeftColor = '#d9534f';
          notification.style.backgroundColor = '#f8d7da';
        }

        notification.style.display = 'block';

        if (duration > 0) {
          setTimeout(function() {
            hidePageNotification();
          }, duration);
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });
      };

      function hidePageNotification() {
        if (notification) {
          notification.style.display = 'none';
        }
      }

      if (notificationClose) {
        notificationClose.addEventListener('click', hidePageNotification);
      }
    }

    /**
     * Initialize cat breeds multi-select functionality
     */
    function initBreedsMultiSelect() {
      const container = document.getElementById('cat-breeds-container');
      if (!container) return;

      const hiddenInput = document.getElementById('cat-breeds-hidden');
      const checkboxes = container.querySelectorAll('[data-breed-checkbox]');
      const otherToggle = container.querySelector('[data-breed-other-toggle]');
      const otherContainer = document.getElementById('breeds-other-container');
      const otherInput = document.getElementById('cat-breeds-other');

      // Update hidden input when checkboxes change
      function updateHiddenInput() {
        const selectedBreeds = [];
        checkboxes.forEach(function(cb) {
          if (cb.checked && cb.value !== 'Other') {
            selectedBreeds.push(cb.value);
          }
        });

        // Add "Other" breeds if specified
        if (otherToggle && otherToggle.checked && otherInput && otherInput.value.trim()) {
          selectedBreeds.push('Other: ' + otherInput.value.trim());
        } else if (otherToggle && otherToggle.checked) {
          selectedBreeds.push('Other');
        }

        if (hiddenInput) {
          hiddenInput.value = selectedBreeds.join(', ');
        }
      }

      // Add change listeners to all checkboxes
      checkboxes.forEach(function(cb) {
        cb.addEventListener('change', function() {
          updateHiddenInput();

          // Clear error state when a breed is selected
          const formGroup = container.closest('.tf-form-group');
          if (formGroup && formGroup.classList.contains('error')) {
            const anyChecked = Array.from(checkboxes).some(function(c) { return c.checked; });
            if (anyChecked) {
              formGroup.classList.remove('error');
            }
          }
        });
      });

      // Toggle "Other" input field visibility
      if (otherToggle && otherContainer) {
        otherToggle.addEventListener('change', function() {
          otherContainer.style.display = this.checked ? 'block' : 'none';
          if (!this.checked && otherInput) {
            otherInput.value = '';
          }
          updateHiddenInput();
        });
      }

      // Update hidden input when "Other" text changes
      if (otherInput) {
        otherInput.addEventListener('input', updateHiddenInput);
      }
    }

    /**
     * Initialize influencer platforms multi-select functionality
     */
    function initPlatformsMultiSelect() {
      const container = document.getElementById('platforms-container');
      if (!container) return;

      const hiddenInput = document.getElementById('platforms-hidden');
      const addBtn = document.getElementById('add-platform-btn');
      let platformIndex = 1; // First entry is index 0

      // Update hidden input with all platform data
      function updateHiddenInput() {
        const entries = container.querySelectorAll('.tf-platform-entry');
        const platformsData = [];

        entries.forEach(function(entry) {
          const select = entry.querySelector('.tf-platform-select');
          const handle = entry.querySelector('.tf-platform-handle');
          const followers = entry.querySelector('.tf-platform-followers');

          if (select && handle && followers) {
            const data = {
              platform: select.value,
              handle: handle.value.trim(),
              followers: followers.value
            };
            // Only add if at least platform is selected
            if (data.platform) {
              platformsData.push(data);
            }
          }
        });

        if (hiddenInput) {
          hiddenInput.value = JSON.stringify(platformsData);
        }

        // Update remove button visibility
        updateRemoveButtons();
        clearErrorIfValid();
      }

      // Update remove button visibility (hide if only one entry)
      function updateRemoveButtons() {
        const entries = container.querySelectorAll('.tf-platform-entry');
        entries.forEach(function(entry, index) {
          const removeBtn = entry.querySelector('.tf-platform-remove-btn');
          if (removeBtn) {
            removeBtn.style.display = entries.length > 1 ? 'flex' : 'none';
          }
          // Update title
          const title = entry.querySelector('.tf-platform-entry-title');
          if (title) {
            title.textContent = 'Platform ' + (index + 1);
          }
        });
      }

      // Clear error state if valid
      function clearErrorIfValid() {
        const formGroup = container.closest('[data-validate-platforms]');
        if (formGroup && formGroup.classList.contains('error')) {
          const entries = container.querySelectorAll('.tf-platform-entry');
          let hasValidEntry = false;
          entries.forEach(function(entry) {
            const select = entry.querySelector('.tf-platform-select');
            const handle = entry.querySelector('.tf-platform-handle');
            const followers = entry.querySelector('.tf-platform-followers');
            if (select && select.value && handle && handle.value.trim() && followers && followers.value) {
              hasValidEntry = true;
            }
          });
          if (hasValidEntry) {
            formGroup.classList.remove('error');
          }
        }
      }

      // Add event listeners to existing entry
      function addEntryListeners(entry) {
        const select = entry.querySelector('.tf-platform-select');
        const handle = entry.querySelector('.tf-platform-handle');
        const followers = entry.querySelector('.tf-platform-followers');
        const removeBtn = entry.querySelector('.tf-platform-remove-btn');

        if (select) select.addEventListener('change', updateHiddenInput);
        if (handle) handle.addEventListener('input', updateHiddenInput);
        if (followers) followers.addEventListener('input', updateHiddenInput);

        if (removeBtn) {
          removeBtn.addEventListener('click', function() {
            entry.remove();
            updateHiddenInput();
          });
        }
      }

      // Add new platform entry
      function addPlatformEntry() {
        const newEntry = document.createElement('div');
        newEntry.className = 'tf-platform-entry';
        newEntry.setAttribute('data-platform-index', platformIndex);
        newEntry.innerHTML = `
          <div class="tf-platform-entry-header">
            <span class="tf-platform-entry-title">Platform ${platformIndex + 1}</span>
            <button type="button" class="tf-platform-remove-btn" aria-label="Remove platform">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
              </svg>
            </button>
          </div>
          <div class="tf-platform-entry-fields">
            <div class="tf-form-group">
              <label class="tf-form-label required">Platform</label>
              <select class="tf-form-select tf-platform-select" required>
                <option value="">Select a platform...</option>
                <option value="instagram">Instagram</option>
                <option value="tiktok">TikTok</option>
                <option value="youtube">YouTube</option>
                <option value="facebook">Facebook</option>
                <option value="twitter">Twitter/X</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div class="tf-form-group">
              <label class="tf-form-label required">Handle / Link</label>
              <input type="text" class="tf-form-input tf-platform-handle" placeholder="e.g., @username or https://..." required>
            </div>
            <div class="tf-form-group">
              <label class="tf-form-label required">Followers</label>
              <input type="number" class="tf-form-input tf-platform-followers" placeholder="10000" min="0" required>
            </div>
          </div>
        `;

        container.appendChild(newEntry);
        addEntryListeners(newEntry);
        platformIndex++;
        updateHiddenInput();
      }

      // Initialize existing entries
      const existingEntries = container.querySelectorAll('.tf-platform-entry');
      existingEntries.forEach(function(entry) {
        addEntryListeners(entry);
      });

      // Add button click handler
      if (addBtn) {
        addBtn.addEventListener('click', addPlatformEntry);
      }

      // Initial update
      updateRemoveButtons();
    }

    /**
     * Update the complete view with API response data
     * @param {HTMLElement} completeView - The complete view container
     * @param {string} role - The role from API response
     * @param {string} status - The status from API response
     * @param {string} message - The message from API response
     */
    function updateCompleteView(completeView, role, status, message) {
      // Get role display name
      const roleDisplayNames = {
        'Breeder': 'Breeder Partner',
        'Influencer': 'Influencer Partner',
        'RescueGroup': 'Rescue Group Partner',
        'NewCatOwner': 'New Cat Owner'
      };
      const roleDisplayName = roleDisplayNames[role] || role;

      // Get status display info
      const statusInfo = {
        'applied': { label: 'Application Submitted', color: '#f57c00', bgColor: '#fff3e0' },
        'pending': { label: 'Pending Review', color: '#f57c00', bgColor: '#fff3e0' },
        'approved': { label: 'Approved', color: '#4caf50', bgColor: '#e8f5e9' },
        'rejected': { label: 'Rejected', color: '#f44336', bgColor: '#ffebee' }
      };
      const currentStatus = statusInfo[status] || statusInfo['applied'];

      // Create dynamic content for the complete view
      const dynamicContent = `
        <div class="tf-apply-result" style="max-width: 600px; margin: 0 auto; padding: 32px; text-align: center;">
          <div style="width: 80px; height: 80px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 24px; font-size: 40px; background-color: ${currentStatus.bgColor}; color: ${currentStatus.color};">
            ${status === 'approved' ? '✓' : '⏳'}
          </div>
          <h2 style="font-size: 24px; font-weight: 700; margin-bottom: 16px; color: #132f63;">
            ${status === 'approved' ? 'Application Approved!' : 'Application Submitted'}
          </h2>
          <span style="display: inline-block; padding: 6px 16px; border-radius: 20px; font-size: 14px; font-weight: 600; margin-bottom: 16px; background-color: ${currentStatus.bgColor}; color: ${currentStatus.color};">
            ${roleDisplayName}
          </span>
          <p style="font-size: 16px; color: #666; line-height: 1.6; margin-bottom: 24px;">
            ${message || 'Thank you for your application. Our team is currently reviewing your information.'}
          </p>
          <div style="display: flex; flex-direction: column; gap: 8px; margin-bottom: 24px; padding: 16px; background-color: #fafafa; border-radius: 8px; text-align: left;">
            <div style="display: flex; justify-content: space-between; font-size: 14px;">
              <span style="color: #888;">Application Type:</span>
              <span style="font-weight: 600; color: #333;">${roleDisplayName}</span>
            </div>
            <div style="display: flex; justify-content: space-between; font-size: 14px;">
              <span style="color: #888;">Status:</span>
              <span style="font-weight: 600; color: ${currentStatus.color};">${currentStatus.label}</span>
            </div>
            <div style="display: flex; justify-content: space-between; font-size: 14px;">
              <span style="color: #888;">Submitted:</span>
              <span style="font-weight: 600; color: #333;">${new Date().toLocaleDateString()}</span>
            </div>
          </div>
          <div style="padding: 16px; background-color: #f8f9fa; border-radius: 8px; font-size: 14px; color: #555;">
            <div style="font-weight: 600; margin-bottom: 4px;">Questions about your application?</div>
            <div>We'll notify you by email once your application is reviewed.</div>
          </div>
        </div>
      `;

      // Replace the content of complete view
      completeView.innerHTML = dynamicContent;
    }

    /**
     * Collect all form data into an object for contact[body]
     */
    function collectFormData() {
      const data = {
        timestamp: new Date().toISOString(),
        form_type: 'tf_apply',
        role: accountType
      };

      // Collect all input, select, textarea values (excluding most hidden inputs)
      const inputs = form.querySelectorAll('input:not([type="hidden"]):not([type="submit"]), select, textarea');
      inputs.forEach(function(input) {
        const name = input.name || input.id;
        if (!name) return;

        // Skip contact form hidden fields
        if (name.startsWith('contact[')) return;

        // Skip individual breed checkboxes (use consolidated cat_breeds instead)
        if (input.hasAttribute('data-breed-checkbox')) return;

        // Clean up name for JSON key
        const key = name.replace(/^customer\[note\]\[|\]$/g, '').replace(/\[/g, '_').replace(/\]/g, '');

        if (input.type === 'checkbox') {
          // Handle multiple checkboxes with same name
          if (input.checked) {
            if (data[key] === undefined) {
              data[key] = input.value === 'true' ? true : input.value;
            } else if (Array.isArray(data[key])) {
              data[key].push(input.value);
            } else {
              data[key] = [data[key], input.value];
            }
          }
        } else if (input.type === 'radio') {
          if (input.checked) {
            data[key] = input.value;
          }
        } else if (input.type === 'file') {
          if (input.files && input.files.length > 0) {
            data[key] = {
              filename: input.files[0].name,
              size: input.files[0].size,
              type: input.files[0].type
            };
          }
        } else {
          if (input.value && input.value.trim()) {
            data[key] = input.value.trim();
          }
        }
      });

      // Collect cat breeds from hidden input (populated by multi-select checkboxes)
      const catBreedsHidden = form.querySelector('#cat-breeds-hidden');
      if (catBreedsHidden && catBreedsHidden.value && catBreedsHidden.value.trim()) {
        data['cat_breeds'] = catBreedsHidden.value.trim();
      }

      // Collect influencer platforms from hidden input (JSON array of platform objects)
      const platformsHidden = form.querySelector('#platforms-hidden');
      if (platformsHidden && platformsHidden.value && platformsHidden.value.trim()) {
        try {
          data['platforms'] = JSON.parse(platformsHidden.value);
        } catch (e) {
          console.error('Failed to parse platforms JSON:', e);
          data['platforms'] = platformsHidden.value.trim();
        }
      }

      return data;
    }

    /**
     * Populate confirmation view with form data
     */
    function populateConfirmView() {
      const step1Container = document.getElementById('tf-confirm-step1');
      const step2Container = document.getElementById('tf-confirm-step2');
      if (!step1Container || !step2Container) return;

      step1Container.innerHTML = '';
      step2Container.innerHTML = '';

      // Get step 1 fields
      const step1Content = wrapper.querySelector('.tf-apply-content[data-content="1"]');
      if (step1Content) {
        const fields = getFieldsFromContent(step1Content);
        step1Container.innerHTML = fields.map(f => createConfirmRow(f.label, f.value)).join('');
      }

      // Get step 2 fields
      const step2Content = wrapper.querySelector('.tf-apply-content[data-content="2"]');
      if (step2Content) {
        const fields = getFieldsFromContent(step2Content);
        step2Container.innerHTML = fields.map(f => createConfirmRow(f.label, f.value)).join('');
      }
    }

    /**
     * Extract field labels and values from a step content
     */
    function getFieldsFromContent(content) {
      const fields = [];
      const formGroups = content.querySelectorAll('.tf-form-group');

      formGroups.forEach(group => {
        const label = group.querySelector('.tf-form-label');
        const input = group.querySelector('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), select, textarea');
        const checkbox = group.querySelector('input[type="checkbox"]');
        const radio = group.querySelector('input[type="radio"]:checked');

        if (label) {
          let labelText = label.textContent.replace(' *', '').trim();
          let value = '';

          if (input) {
            if (input.tagName === 'SELECT') {
              const selectedOption = input.options[input.selectedIndex];
              value = selectedOption ? selectedOption.text : '';
            } else if (input.type === 'file') {
              value = input.files.length > 0 ? input.files[0].name : 'No file selected';
            } else {
              value = input.value || '';
            }
          } else if (checkbox) {
            value = checkbox.checked ? 'Yes' : 'No';
          } else if (radio) {
            value = radio.value || '';
          }

          if (labelText && value) {
            fields.push({ label: labelText, value: value });
          }
        }
      });

      return fields;
    }

    /**
     * Create a confirmation row HTML
     */
    function createConfirmRow(label, value) {
      return `<div class="tf-confirm-row">
        <span class="tf-confirm-label">${label}</span>
        <span class="tf-confirm-value">${value}</span>
      </div>`;
    }

    /**
     * Navigate to a specific step
     */
    function goToStep(step) {
      currentStep = step;

      // Update tabs
      tabs.forEach(tab => {
        const tabStep = parseInt(tab.dataset.tab);
        tab.classList.remove('active', 'completed');
        
        if (tabStep === step) {
          tab.classList.add('active');
          tab.disabled = false;
        } else if (tabStep < step) {
          tab.classList.add('completed');
          tab.disabled = false;
        } else {
          tab.disabled = true;
        }
      });

      // Update content
      contents.forEach(content => {
        const contentStep = parseInt(content.dataset.content);
        content.classList.toggle('active', contentStep === step);
      });

      // Hide validation messages
      hideValidation(step);
    }

    /**
     * Validate a specific step
     */
    function validateStep(step) {
      const content = wrapper.querySelector(`.tf-apply-content[data-content="${step}"]`);
      if (!content) return true;

      const requiredFields = content.querySelectorAll('[required]');
      const errors = [];
      let isValid = true;

      // Clear previous errors
      content.querySelectorAll('.tf-form-group.error').forEach(group => {
        group.classList.remove('error');
      });

      requiredFields.forEach(field => {
        const formGroup = field.closest('.tf-form-group');
        let fieldValid = true;

        if (field.type === 'checkbox') {
          fieldValid = field.checked;
        } else if (field.type === 'email') {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          fieldValid = field.value.trim() !== '' && emailRegex.test(field.value);
        } else if (field.type === 'tel' && field.hasAttribute('data-phone-au')) {
          // Australian phone number validation
          // Matches: +61 4XX XXX XXX, 04XX XXX XXX, +612XXXXXXXX, 02XXXXXXXX, etc.
          const auPhoneRegex = /^(\+?61|0)[2-478](\s?\d){8}$/;
          const cleanedPhone = field.value.trim().replace(/[\s\-()]/g, '');
          fieldValid = cleanedPhone !== '' && auPhoneRegex.test(cleanedPhone);
        } else {
          fieldValid = field.value.trim() !== '';
        }

        if (!fieldValid) {
          isValid = false;
          if (formGroup) {
            formGroup.classList.add('error');
          }
          // Get error message
          const label = formGroup?.querySelector('.tf-form-label');
          const errorDiv = formGroup?.querySelector('.tf-form-error');
          const fieldName = label ? label.textContent.replace(' *', '').trim() : 'Field';
          const errorMsg = errorDiv ? errorDiv.textContent : `Please enter ${fieldName}`;
          errors.push(errorMsg);
        }
      });

      // Password validation
      const passwordField = content.querySelector('input[name="customer[password]"]');
      if (passwordField && passwordField.value.length > 0 && passwordField.value.length < 5) {
        const formGroup = passwordField.closest('.tf-form-group');
        if (formGroup) formGroup.classList.add('error');
        errors.push('Password must be at least 5 characters');
        isValid = false;
      }

      // Cat breeds multi-select validation
      const breedsContainer = content.querySelector('[data-validate-breeds]');
      if (breedsContainer) {
        const hiddenInput = breedsContainer.querySelector('#cat-breeds-hidden');
        const formGroup = breedsContainer.closest('.tf-form-group');
        if (hiddenInput && (!hiddenInput.value || hiddenInput.value.trim() === '')) {
          isValid = false;
          if (formGroup) {
            formGroup.classList.add('error');
          }
          const errorDiv = formGroup?.querySelector('.tf-form-error');
          const errorMsg = errorDiv ? errorDiv.textContent : 'Please select at least one cat breed';
          errors.push(errorMsg);
        }
      }

      // Influencer platforms multi-select validation
      const platformsContainer = content.querySelector('[data-validate-platforms]');
      if (platformsContainer) {
        const hiddenInput = platformsContainer.querySelector('#platforms-hidden');
        const entries = platformsContainer.querySelectorAll('.tf-platform-entry');
        let hasValidPlatform = false;
        let hasIncompleteEntry = false;

        entries.forEach(function(entry) {
          const select = entry.querySelector('.tf-platform-select');
          const handle = entry.querySelector('.tf-platform-handle');
          const followers = entry.querySelector('.tf-platform-followers');

          const platformVal = select ? select.value : '';
          const handleVal = handle ? handle.value.trim() : '';
          const followersVal = followers ? followers.value : '';

          // Check if this entry is complete
          if (platformVal && handleVal && followersVal) {
            hasValidPlatform = true;
            entry.classList.remove('error');
          } else if (platformVal || handleVal || followersVal) {
            // Partially filled - mark as incomplete
            hasIncompleteEntry = true;
            entry.classList.add('error');
          }
        });

        if (!hasValidPlatform) {
          isValid = false;
          platformsContainer.classList.add('error');
          const errorDiv = platformsContainer.querySelector('.tf-form-error');
          const errorMsg = errorDiv ? errorDiv.textContent : 'Please add at least one platform with all required fields';
          errors.push(errorMsg);
        } else if (hasIncompleteEntry) {
          isValid = false;
          platformsContainer.classList.add('error');
          errors.push('Please complete all fields for each platform or remove incomplete entries');
        } else {
          platformsContainer.classList.remove('error');
        }
      }

      if (!isValid) {
        showValidation(step, errors);
      }

      return isValid;
    }

    /**
     * Show validation errors
     */
    function showValidation(step, errors) {
      const validationDiv = document.getElementById(`tf-validation-step${step}`);
      const listDiv = document.getElementById(`tf-validation-list-step${step}`);

      if (validationDiv && listDiv) {
        listDiv.innerHTML = errors.map(err => `<li>${err}</li>`).join('');
        validationDiv.style.display = 'block';
      }
    }

    /**
     * Hide validation messages
     */
    function hideValidation(step) {
      const validationDiv = document.getElementById(`tf-validation-step${step}`);
      if (validationDiv) {
        validationDiv.style.display = 'none';
      }
    }

    // Real-time validation on blur
    wrapper.querySelectorAll('input, select, textarea').forEach(field => {
      field.addEventListener('blur', function() {
        const formGroup = this.closest('.tf-form-group');
        if (!formGroup) return;

        if (this.hasAttribute('required')) {
          let isValid = true;

          if (this.type === 'checkbox') {
            isValid = this.checked;
          } else if (this.type === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            isValid = this.value.trim() !== '' && emailRegex.test(this.value);
          } else if (this.type === 'tel' && this.hasAttribute('data-phone-au')) {
            // Australian phone number validation
            const auPhoneRegex = /^(\+?61|0)[2-478](\s?\d){8}$/;
            const cleanedPhone = this.value.trim().replace(/[\s\-()]/g, '');
            isValid = cleanedPhone !== '' && auPhoneRegex.test(cleanedPhone);
          } else {
            isValid = this.value.trim() !== '';
          }

          formGroup.classList.toggle('error', !isValid);
        }
      });

      // Clear error on input
      field.addEventListener('input', function() {
        const formGroup = this.closest('.tf-form-group');
        if (formGroup && formGroup.classList.contains('error')) {
          if (this.value.trim() !== '') {
            formGroup.classList.remove('error');
          }
        }
      });
    });
  }
})();
